"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var elementProps = {
  element: _propTypes.default.object,
  onDragMove: _propTypes.default.func,
  onTransform: _propTypes.default.func,
  layer: _propTypes.default.object,
  showHelper: _propTypes.default.bool,
  helperWidth: _propTypes.default.number,
  helperHeight: _propTypes.default.number
};
var _default = elementProps;
exports.default = _default;